import type { FC, MouseEventHandler, ReactElement } from 'react';
import React from 'react';

import { Icon as IconPresenter } from '../../Icon';
import { withCloseIcon } from '../../Icon/_glyph/Close';
import { compose } from '../../lib/compose';
import { TextinputIcon } from '../Icon/Textinput-Icon';
import { cnTextinput } from '../Textinput.cn';

import './Textinput-Clear.css';

const IconClose = compose(withCloseIcon)(IconPresenter);

export interface ITextinputClearProps {
    /**
     * Видимость крестика
     */
    visible?: boolean;

    /**
     * Размер крестика
     */
    size?: string;

    /**
     * Тема крестика
     */
    theme?: string;

    /**
     * Внешний вид крестика
     */
    view?: string;

    /**
     * Тип крестика
     */
    icon?: ReactElement;

    /**
     * Дополнительный класс
     */
    className?: string;

    /**
     * Обработчик клика
     */
    onClick?: MouseEventHandler<HTMLSpanElement>;

    /**
     * Обработчик события `onMouseDown`
     */
    onMouseDown?: MouseEventHandler<HTMLSpanElement>;
}

export const TextinputClear: FC<ITextinputClearProps> = ({
    visible,
    className,
    theme,
    view,
    icon,
    ...props
}) => {
    const iconProps = { className: cnTextinput('Clear', { visible }, [className]) };
    const IconComonent = icon ? (
        React.cloneElement(icon, iconProps)
    ) : (
        <IconClose glyph="close" sizeManagement="parent" {...iconProps} />
    );

    return <TextinputIcon {...props} component={IconComonent} />;
};
